
// const BASE_URL = `http://10.168.88.12:9017/v1/consent`

//const BASE_URL = `http://10.168.24.4:9006/consent/v1`

// const BASE_URL =  "https://api.consent.jio.com/consent/v1"

// const BASE_URL = `http://10.168.24.4:9006/consent/v1`

// const BASE_URL =  "https://api.consent.jio.com/consent/v1"

// const TOKEN = `http://10.168.24.4:9006/oauth2/v2.0/token`

const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY

const BASE_URL = process.env.REACT_APP_BASE_URL
const BASE_URL_NEW = process.env.REACT_APP_BASE_URL_NEW
const BASE_URL_V4 = process.env.REACT_APP_BASE_URL_V4
const BASE_URL_BACKUP = `https://api.consentdev.jio.com/consent/v1` 
//const BASE_URL = `http://10.173.152.4:9006/v1/consent`
const BASE_OTP = `http://10.162.6.62:9010` 

const BASE_URL_FOR_COOKIE_CONSENT = `http://10.162.6.75:4000` 
const BASE_URL_FOR_COOKIE_CONSENT_WSO2 = 'https://api.consentdev.jio.com/cookie/v1'

const BASE_URL_TEMP = 'https://g2c-az-apim-le.jio.com/consent/v1.3'
 const TOKEN = process.env.REACT_APP_TOKEN

//const TOKEN = `http://10.173.152.4:9006/oauth2/v2.0/token`


////LOGIN
const INIT_OTP = `${BASE_URL}/initOtp`
const ENC_OTP = `${BASE_OTP}/encrypt`
const VERIFY_OTP = `${BASE_URL}/validateOtp`

//// TEMPLATE
const GET_TEMPLATE_LIST = `${BASE_URL}/getTemplatesByParam`
const CREATE_TEMPLATE = `${BASE_URL}/onboardTemplate`

//// DATATYPE
const GET_DATATYPE_LIST = `${BASE_URL}/getDataType/dpid`
const CREATE_DATATYPE = `${BASE_URL}/dataType`

//// PURPOSE
const GET_PURPOSE_LIST = `${BASE_URL}/getPurpose/dpid`
const CREATE_PURPOSE= `${BASE_URL}/onboardPurpose`

const GET_ENTITY_LIST = `${BASE_URL}/getEntity/all`

const GET_DASHBOARD = `${BASE_URL}/getDashboard`
const GET_TEMPLATE_DETAIL = `${BASE_URL}/getTemplateDetails`
const GET_CONSENT_DETAIL_TEMPLATE_ID = `${BASE_URL}/GetConsentsByTemplateId`
const GET_PROFILE_DATA = `${BASE_URL}/getClientInfo`
const UPDATE_CLIENT_LOGO = `${BASE_URL}/updateLogo`
const UPDATE_PREFERENCE_CENTER = `${BASE_URL}/consentPopup`
const GET_PREFERENCE_CENTER = `${BASE_URL}/consentPopup`
const changeTheme = `${BASE_URL}/theme`
const GET_FAQ = `${BASE_URL}/FAQs`


const SCAN_COOKIES = `${BASE_URL_FOR_COOKIE_CONSENT_WSO2}/scan`
const COOKIE_SCANNING_STATUS_REPORT = `${BASE_URL_FOR_COOKIE_CONSENT_WSO2}/status`

const fetchCookieDetailsbyCookieName = `${BASE_URL}/cookies`  
const POST_COOKIES_SCAN_REPORT = `${BASE_URL}/postCookieScanReport`
const GET_COOKIE_CONSENT_LOGS = `${BASE_URL}/getAllCookiesConsent`
const VERIFY_CONSENT_ENDPOINT = `${BASE_URL}/getcvc`
const GET_CONSENT_LIST_BY_CUST = `${BASE_URL}/getConsentByParam`
const CREATE_BULK_CONSENT = `${BASE_URL}/createBulkConsent`
const CREATE_CONSENT_GROUP = `${BASE_URL}/consentGroup`
//const CREATE_CONSENT_GROUP = `http://10.162.6.84:9025/v1.5/consent/consentGroup`

//// CONSENT GROUP
const GET_CONSENT_GROUP = `${BASE_URL}/getConsentGroupsByParam`

//// CONSENT GROUP BY GROUPID
const GET_CONSENTGROUPID = `${BASE_URL}/consentGroup`


//// CONSENT GROUP BY GROUPID
const GET_TEMPLATE_DETAIL_TEMPLATE_ID = `${BASE_URL}/getTemplateDetails`

//// UPDATE CONSENT GROUP
const UPDATE_CONSENT_GROUP_DETAILS = `${BASE_URL}/consentGroup`

const GET_TEMPLATE_BY_CONSENT_GROUPID = `${BASE_URL}/getTemplatesByParam`

const vals = { 
   INIT_OTP,
   ENC_OTP,
   VERIFY_OTP,
   PUBLIC_KEY,
   CREATE_TEMPLATE,
   GET_TEMPLATE_LIST,
   CREATE_DATATYPE,
   GET_DATATYPE_LIST,
   CREATE_PURPOSE,
   GET_PURPOSE_LIST,
   GET_ENTITY_LIST,
   GET_TEMPLATE_DETAIL,
   GET_DASHBOARD,
   TOKEN,
   GET_CONSENT_DETAIL_TEMPLATE_ID,
   GET_PROFILE_DATA,
   UPDATE_CLIENT_LOGO,
   UPDATE_PREFERENCE_CENTER,
   GET_PREFERENCE_CENTER,
   changeTheme,
   GET_FAQ,
   SCAN_COOKIES,
   COOKIE_SCANNING_STATUS_REPORT,
   fetchCookieDetailsbyCookieName,
   POST_COOKIES_SCAN_REPORT,
   GET_COOKIE_CONSENT_LOGS,
   CREATE_BULK_CONSENT,
   VERIFY_CONSENT_ENDPOINT,
   GET_CONSENT_LIST_BY_CUST,
   GET_CONSENT_GROUP,
   CREATE_CONSENT_GROUP,
   GET_CONSENTGROUPID,
   GET_TEMPLATE_DETAIL_TEMPLATE_ID,
   UPDATE_CONSENT_GROUP_DETAILS,
   GET_TEMPLATE_BY_CONSENT_GROUPID
 };

export default vals
